import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import CreateScannedDoc from '..';
import { MainContext } from '../../../../../../context/MainContext';
import {
  getScannedDocument,
  updateScannedDocument,
} from '../../../../../../services/api/scannedDocuments';
import { FORMSATTR, VALIDABLE_FALSE, VALIDABLE_TRUE } from './formItems';

const transform = (loadedLaboratoryNote) => {
  const newArray = [];
  [3, 7, 28, 60].forEach((element) => {
    if (
      loadedLaboratoryNote[`compressive_strength_${element}_1`] !== null ||
      loadedLaboratoryNote[`compressive_strength_${element}_2`] !== null ||
      loadedLaboratoryNote[`compressive_strength_${element}_3`] !== null
    ) {
      newArray.push({
        day: element || '',
        value1: loadedLaboratoryNote[`compressive_strength_${element}_1`] || '',
        value2: loadedLaboratoryNote[`compressive_strength_${element}_2`] || '',
        value3: loadedLaboratoryNote[`compressive_strength_${element}_3`] || '',
      });
    }
  });
  const csRegex = new RegExp(/^compressive_strength_(\d*)_(\d)/);
  const days = new Set();
  Object.keys(
    loadedLaboratoryNote.strength_extra ||
      loadedLaboratoryNote.ave_strength_extra,
  ).forEach((key) => {
    const dayRegexArray = csRegex.exec(key);
    if (dayRegexArray) days.add(dayRegexArray[1]);
  });
  days.forEach((day) => {
    newArray.push({
      day: day,
      value1:
        loadedLaboratoryNote.strength_extra[`compressive_strength_${day}_1`] ||
        '',
      value2:
        loadedLaboratoryNote.strength_extra[`compressive_strength_${day}_2`] ||
        '',
      value3:
        loadedLaboratoryNote.strength_extra[`compressive_strength_${day}_3`] ||
        '',
    });
  });
  return newArray;
};

const UpdateLaboratoryScannedDoc = () => {
  const intl = useIntl();
  const { setLoading, setError } = useContext(MainContext);

  const { sdId } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [loadedTemplate, setLoadedTemplate] = useState({});
  const [validated, setValidated] = useState(null);

  const updateSDLab = async (regions, formState) => {
    try {
      await updateScannedDocument(
        sdId,
        {
          docket_number: formState.docket_number,
          laboratory_note_data: {
            compressive_strength_3_1: null,
            compressive_strength_3_2: null,
            compressive_strength_3_3: null,
            compressive_strength_7_1: null,
            compressive_strength_7_2: null,
            compressive_strength_7_3: null,
            compressive_strength_28_1: null,
            compressive_strength_28_2: null,
            compressive_strength_28_3: null,
            compressive_strength_60_1: null,
            compressive_strength_60_2: null,
            compressive_strength_60_3: null,
            ...formState,
          },
          regions: regions,
        },
        'laboratory',
      );

      return 'scannedDocUpdated';
    } catch (response) {
      setError(response);
    }
  };

  useEffect(() => {
    setLoading(true);

    async function loadTemplate() {
      try {
        const loadedSD = (await getScannedDocument(sdId)).data;
        let readedTemplate = loadedSD.template_data || {};
        setValidated(loadedSD.validated);
        setLoadedTemplate(readedTemplate);
        let loadedLaboratoryNote =
          loadedSD.laboratory_note_data ??
          loadedSD.no_validated_laboratory_note_data;
        const loadedLab = readedTemplate?.laboratory_data || {};
        const csArray = transform(loadedLaboratoryNote);
        setInitialData({
          form: {
            templateName:
              readedTemplate.name || intl.formatMessage({ id: 'noTemplate' }),
            supplier_id:
              readedTemplate.supplier ||
              intl.formatMessage({ id: 'noSuppliers' }),
            phone_number: loadedLab.phone_number,
            email: loadedLab.email,
          },
          regions: loadedSD.regions,
          regionsValue: {
            docket_number: loadedSD.docket_number,
            reference_number: loadedLaboratoryNote.reference_number,
            compressive_strength: csArray,
          },
        });
      } catch (error) {
        setError(error);
      }
    }
    loadTemplate();
  }, [setLoading, sdId, intl, setError]);

  useEffect(() => {
    setLoading(false);
  }, [setLoading]);

  if (validated !== null)
    return (
      <CreateScannedDoc
        formsAttr={FORMSATTR}
        closeForm={updateSDLab}
        model="laboratory"
        initialData={initialData}
        validable={validated ? VALIDABLE_TRUE : VALIDABLE_FALSE}
        loadedTemplate={loadedTemplate}
      />
    );
  return null;
};

export default UpdateLaboratoryScannedDoc;
